var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarStupaidVerified1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04074 1.56687C6.21425 1.1638 6.78575 1.1638 6.95926 1.56687L8.14795 4.32823C8.22097 4.49787 8.38155 4.61343 8.56559 4.6288L11.7293 4.893C12.1824 4.93084 12.3539 5.50479 11.9958 5.78501L9.69659 7.58444C9.54425 7.70367 9.47435 7.90008 9.51712 8.08874L10.2485 11.3147C10.3472 11.7503 9.86887 12.0869 9.49221 11.8469L6.76866 10.1117C6.60477 10.0073 6.39523 10.0073 6.23134 10.1117L3.50779 11.8469C3.13113 12.0869 2.65275 11.7503 2.7515 11.3147L3.48288 8.08874C3.52565 7.90007 3.45575 7.70367 3.30341 7.58444L1.00419 5.78501C0.646127 5.50479 0.817632 4.93084 1.27073 4.893L4.43441 4.6288C4.61845 4.61343 4.77903 4.49787 4.85205 4.32823L6.04074 1.56687Z",
    stroke: "#0C0C0C",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarStupaidVerified1);
export default __webpack_public_path__ + "static/media/Star-stupaid-verified1.b9ebc812bbdc03d2ee32023f9c01da39.svg";
export { ForwardRef as ReactComponent };